// Округление денежных сумм до копеек (2 знака). +Number.EPSILON — чтобы 1.005 не терялось в 1.00
export const roundToKopecks = (value: number): number =>
  Math.round((value + Number.EPSILON) * 100) / 100
